export default [
  require("./templates/playerfacts_0001.json"),
  require("./templates/playerstats_0002.json"),
  require("./templates/teamfacts_0003.json"),
  require("./templates/playercompare_0004.json"),
  require("./templates/teamcompare_0005.json"),
];
